"use strict";

const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");


class Input extends HTMLElement {
    constructor(template) {
        super(template);

        this.root = this.attachShadow({ mode: "open" });

        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);
        this.inputElement = this.root.querySelector('input[type="radio"]');
        this.labelElement = this.root.querySelector("label");

        this.initSlots();


        this.inputElement.addEventListener("change", function (event) {
            // the following line of code is needed in the checkbox component:
            // to be understood why is not radio component does not need it
            // this.checked = this.inputElement.checked;
            this.dispatchEvent(new CustomEvent("change", {
                detail: {
                    value: this.inputElement.value
                },
                bubbles: true
                // composed: true
            }))
        }.bind(this));


    }

    static get observedAttributes() {
        return [
            "value",
            "label",
            "name",
            "checked",
            "disabled"
        ];
    }


    get value() {
        return this.inputElement.value.trim();
    }
    set value(value) {
        this.setAttribute("value", value);
    }
    get checked() {
        return this.hasAttribute("checked");
    }
    set checked(value) {
        if (value) {
            this.setAttribute("checked", value);
        } else {
            this.removeAttribute("checked");
        }
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(value) {
        this.inputElement = this.root.querySelector('input[type="radio"]')
        if (value) {
            this.inputElement.setAttribute("disabled", "");
        } else {
            this.inputElement.removeAttribute("disabled");
        }
    }
    get label() {
        return this.getAttribute("label");
    }
    set label(value) {
        this.setAttribute("label", value);
    }
    get name() {
        return this.getAttribute("name");
    }
    set name(value) {
        this.setAttribute("name", value);
    }


    initSlots () {
        if (this.innerHTML) {

        }
    }


    renderAttribute (name, value) {

        switch (name) {
            case "name":
                this.inputElement[name] = this[name];
                break;
            case "checked":
                if (this.checked) {
                    this.inputElement.setAttribute("checked", "");
                } else {
                    this.inputElement.removeAttribute("checked");
                }
                break;
            case "value":
                this.inputElement.value = value;
                break;
            case "label":
                const radio = this.inputElement;
                this.labelElement.textContent = value;
                this.labelElement.prepend(radio);
                this.inputElement = radio;
                break;
            default:
                break;
        }
    }


    attributeChangedCallback(name, oldVal, newVal) {
        this.renderAttribute(name, newVal);
    }


}

window.customElements.define("swiftref-radio-button", Input);

module.exports = Input;
